import React from "react";
import { useIsAndroidApp } from "@/hooks/useLaunchContext";

/**
 * Renders a clickable mailto: link on the web, but plain (non-clickable) text inside the
 * Android app (TWA) - Google Play review flags apps that open external intents (mail client,
 * browser, etc.) via links embedded in web content, so the address is still fully visible/
 * copyable by the user, just not an <a href="mailto:..."> tap target.
 */
export default function SafeMailLink({ email, className }) {
  const isAndroidApp = useIsAndroidApp();
  if (isAndroidApp) return <span className={className}>{email}</span>;
  return <a href={`mailto:${email}`} className={className}>{email}</a>;
}
